import { render, staticRenderFns } from "./sup-faq.vue?vue&type=template&id=1e52ad0e"
import script from "./sup-faq.vue?vue&type=script&lang=js"
export * from "./sup-faq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports